<template>
  <div class="">
    <div class="dash-card" v-for="(item, index) in dashItems">
      <div class="rectangle">
        <template>
          <router-link :to="item.url">
            <div class="borderRadius" :style="{ backgroundColor: item.color }">
              <div class="paddingTop5px">
                <a :href="item.url" class=" header-card alignTextMarginLeft">{{ item.name }}</a>
              </div>
              <div></div>
            </div>
            <div class="dash-card-content">
              <div class="paddingTop7px"><a :href="item.url"
                                            class="content-dashboard-card alignTextMarginLeft">{{ item.description
                }}</a></div>
              <div class="dash-card-number">{{countEventByStatus(item.eventStatus)}}</div>
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'subHeader',
    props: {
      dashItems: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS'
      })
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .dash-card {
    height: 260px;
    float: left;
    .rectangle {
    height: 220px;
    width: 351px;
    border-radius: 3px;
    background-color: @white;
    margin: 20px;
    box-shadow: 0 2px 1px 1px rgba(0,0,0,0.1);
    &:hover {
      box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);
      margin-top: 17px;
      margin-bottom: 23px;
      transition: all 120ms cubic-bezier(0.590, 0.000, 0.445, 0.995);
    }
      .dash-card-content {
        .dash-card-number {
          font-size: 5em;
          text-align: center;
          color: @black;
          margin-top: 20px;
        }
      }
    }
  }

  .alignTextMarginLeft {
    margin-left: 15px;
    cursor: pointer;
  }

  .borderRadius {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    height: 46px;
  }

  .paddingTop7px {
    padding-top: 7px;
  }

  .content-dashboard-card:hover {
    color: @black;
  }

  .paddingTop5px {
    padding-top: 5px;
  }

  .header-card:hover {
    color: @white;
  }

</style>



// WEBPACK FOOTER //
// DashCards.vue?4c8e0962